import React, { useState } from 'react';
import Button from '../../../Button/Button';
import './HeroSection.scss';
import hvideoBg from "../../../../assets/us/header-bg.mp4";

function HeroSection() {
    const [email, setEmail] = useState("");

    const handleSubmit = (event) => {
        event.preventDefault();
        if (email) {
            window.location.href = `https://vymo.com/us/request-demo/?email=${encodeURIComponent(email)}`;
        }
    };

    return (
        <section className="relative section-pad hero-section overflow-hidden mt-[62px] md:mt-[0px] pt-[100px] md:pt-[170px] mb-6">
          <div className="overlay"></div>
          <div className="video-docker absolute top-0 left-0 w-full h-full overflow-hidden">
              <video className="min-w-full min-h-full absolute object-cover" autoPlay muted loop poster="/img/us/home-bg.avif">
                <source src={hvideoBg}></source>
              </video>
          </div>
          <div className="video-content space-y-2 z-10">
            <div className="container mt-4 lg:mt-2 xl:mt-3 mb-0 md:pt-[50px] 2xl:pt-[95px] pb-[50px] md:pb-[40px] 2xl:pb-[50px]">
                <div className="flex flex-col justify-between items-center px-[15px] xl:px-0 m-pt-4 min-h-[400px] md:min-h-[375px]">
                  <div className="text-center self-center items-center">
                    <h1
                      className="font-bold text-32 md:text-[64px] leading-[40px] md:leading-[64px] lg:mt-0 relative z-10 w-full md:w-4/5 mx-auto text-[#232632]" data-aos="fade-up">
                    Driving <span>Insurance Distribution</span> and Producer Transformation
                    </h1>
                    <p className="font-medium text-16 md:text-18 md:leading-7 mt-4.5 leading-[28px] xs:mt-0 relative z-10 text-[#232632] opacity-80" data-aos="fade-up" data-aos-delay="200">
                    Powered by AI to Optimize All Stages of the Producer Lifecycle
                    </p>

                    <div className="flex w-full md:w-100 justify-center font-medium z-10 relative mt-[52px]" data-aos="fade-up" data-aos-delay="400">
                      <form onSubmit={handleSubmit}>
                        <input 
                          type="email" 
                          placeholder="Work Email*" 
                          className="rounded-l-lg py-[14px] w-80 md:w-[370px] px-1 md:px-[18px] text-14 md:text-16 flex-[0.8] md:flex-initial focus:outline-none" 
                          required
                          value={email} 
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <button 
                          type="submit" 
                          className="btn btn-primary-red btn-primary text-14 md:text-16 !rounded-none !rounded-r-lg h-[54px] hover:border-0"
                        >
                          Book Demo
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </section>
    );
}

export default HeroSection;
